//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../components/ImageUploader";
import util from "../../lib/util";

export default {
    name: "qscode",
    components: {ImageUploader},
    data() {
        return {
            projectId: 0,
            downloadUrl: util.ApiUrl + 'file/download/',
            // imgStr: '',
            csQRCodeDto: {}
        }
    },
    methods: {
        getCode() {
            abp.ajax.get('/api/services/app/Project/GetCsQRCode?projectId=' + this.projectId).then(res => {
                this.csQRCodeDto = res.data.result;
            }).finally(() => {

            })
        }
    },
    created() {
        this.projectId = parseInt(this.$route.params.projectId) || 0;
        this.getCode()

    }
}
